import {
    type GetAllDriveFilesResponseType,
    type GetAllDriveFilesRequestType
} from "./type";
import {
    request
} from "../request";

const GetAllDriveFiles = async (params: GetAllDriveFilesRequestType): Promise<GetAllDriveFilesResponseType> => {
    return await request<GetAllDriveFilesResponseType>("/drive/getAllDriveFiles", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default GetAllDriveFiles;
